import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IStuLopViewModel } from "../../../model/respone/category/IStuLopViewModel";
import { generateActionTypeIds } from "../../action-types/generateActionTypeIds";
import IGenericActionType from "../../action-types/IGenericActionType";

export const eLopActionsObj = {
  LOAD_LOP_BY_USER_START: undefined,
  LOAD_LOP_BY_USER_SUCCESS: {} as IStuLopViewModel[],
  LOAD_LOP_BY_USER_ERROR: "",
  
  LOAD_ALL_START: undefined,
  LOAD_ALL_SUCCESS: {} as IStuLopViewModel[],
  LOAD_ALL_ERROR: "",
}

export const eLopActionIds = generateActionTypeIds(eLopActionsObj, "LOP");
export type ILopActionTypes = IGenericActionType<typeof eLopActionsObj, "LOP">;